import { createMuiTheme } from '@material-ui/core/styles';
import { merge } from '../utils';

var createTheme = function createTheme() {
  var dark = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var options = arguments.length > 1 ? arguments[1] : undefined;
  var finalTheme = merge({
    zIndex: {
      cookiesBanner: 1400,
      backToTop: 1300
    },
    palette: {
      type: dark ? 'dark' : 'light',
      links: dark ? '#19b9d2' : '#0066cc',
      primary: {
        main: '#1976d2'
      },
      secondary: {
        main: '#b34700'
      }
    },
    mixins: {
      backToTop: {
        startHeight: 20
      }
    },
    typography: {
      paragraph: {
        maxWidth: 650
      }
    }
  }, options || {});
  return createMuiTheme(finalTheme);
};

export default createTheme;